import TestComponent from "./TestComponent";
import Welcome from "./Welcome";
import type { TablerIconsProps } from "@tabler/icons-react";

import NotFound from "../components/common/404";

import { CategoryList, CreateCategory, EditCategory } from "../pages/categories";
import { ArtistList, CreateArtist, EditArtist } from "../pages/artist";
import { CreateSong, EditSong, ImportExcel } from "../pages/song";
import { UserList, CreateUser, EditUser } from "../pages/users";
import { CustomerList, EditCustomer, CustomerDetail, CustomerListPaginated } from "../pages/customers";
import { SectionList, CreateSection, EditSection } from "../pages/sections";
import { CreateUserSubscription, EditUserSubscription, EditUserSubscriptionFilteredList } from "../pages/user-subscriptions";
import { SubscriptionList, CreateSubscription, EditSubscription } from "../pages/subscriptions";
import { BannerList, CreateBanner, EditBanner } from "../pages/banner";
import { ArticleList, CreateArticle, EditArticle } from "../pages/article";
import { SongGroupList, CreateSongGroup, EditSongGroup } from "../pages/song-group";
import { NotificationList, SendNotification } from "../pages/notification";
import { SongStatsList } from "../pages/song-stats";
import { ColorList, EditColor, CreateColor } from "../pages/color";
import { ContactList, EditContact, CreateContact } from "../pages/contact";
import { Playlists, EditPlaylist, CreatePlaylist } from "../pages/playlist";
import { VersionList, EditVersion } from "../pages/version";
import { PlaceList, CreatePlace, EditPlace } from "../pages/places";
import { SongModifyRequest, SongModifyEdit } from "../pages/modify-requests/song";
import { SongFileRequest, SongFileEdit } from "../pages/modify-requests/file";
import { StatementList, StatementEdit } from '../pages/statements';
import LibraryNew from "../pages/library/New";

import {
    IconUsers,
    IconFiles,
    IconUser,
    IconPlaylist,
    IconCategory,
    IconCurrencyTugrik,
    IconBoxMultiple,
    IconTags,
    IconAd,
    IconNews,
    IconRobot,
    IconBellRinging,
    IconChartBar,
    IconPalette,
    IconPhone,
    Icon123,
    IconMapPins,
    IconFilePencil,
    IconWritingSign,
    IconBooks,
    IconFileInvoice
} from "@tabler/icons-react";

export interface IRoute {
    key: string;
    path: string;
    element: () => JSX.Element;
    standAlone?: boolean;
    name?: string;
    parent?: string;
    visible?: boolean;
    icon?: (props: TablerIconsProps) => JSX.Element;
    menuKey?: string;
    isGroupHeader?: boolean;
}

const routes: IRoute[] = [
    { key: '404', path: '/*', element: NotFound },
    { key: 'Welcome', path: '/', element: Welcome },
    { key: 'TestComponent', path: '/mz/test', element: TestComponent },

    { key: 'group-ebook', path: '', element: CategoryList, visible: true, name: 'Цахим ном', icon: IconFiles, isGroupHeader: true },

    /*** Place ***/
    { key: 'place', path: '/place', element: PlaceList, visible: true, name: 'Газрууд', icon: IconMapPins },
    { key: 'create-place', path: '/place/new', element: CreatePlace, name: 'Газрууд', menuKey: 'place' },
    { key: 'edit-place', path: '/place/edit', element: EditPlace, name: 'Газрууд', menuKey: 'place' },

    /*** Artist ***/
    { key: 'artist', path: '/artist', element: ArtistList, visible: true, name: 'Уран бүтээлч', icon: IconUser },
    { key: 'create-artist', path: '/artist/new', element: CreateArtist, name: 'Уран бүтээлч', menuKey: 'artist'},
    { key: 'edit-artist', path: '/artist/edit', element: EditArtist, name: 'Уран бүтээлч', menuKey: 'artist' },

    /*** Song Modify Request ***/
    { key: 'song-modify-request', path: '/modify-request/song', element: SongModifyRequest, visible: true, name: 'Дуу засварлах хүсэлт', icon: IconWritingSign },
    { key: 'song-modify-request-edit', path: '/modify-request/song/edit', element: SongModifyEdit, name: 'Дуу засварлах хүсэлт' },
    { key: 'song-file-request', path: '/modify-request/file', element: SongFileRequest, visible: true, name: 'Файлтай хүсэлт', icon: IconFilePencil },
    { key: 'song-file-request-edit', path: '/modify-request/file/edit', element: SongFileEdit, name: 'Файлтай хүсэлт' },


    { key: 'library', path: '/library', element: LibraryNew, visible: true, name: 'Дууны сан', icon: IconBooks },

    { key: 'group-content', path: '', element: CategoryList, visible: true, name: 'Контент', icon: IconFiles, isGroupHeader: true },

    /*** Song Group ***/
    { key: 'song-group', path: '/song-group', element: SongGroupList, visible: true, name: 'Дууны бүлэг', icon: IconPlaylist },
    { key: 'create-song-group', path: '/song-group/new', element: CreateSongGroup, name: 'Дууны бүлэг', menuKey: 'song-group' },
    { key: 'edit-song-group', path: '/song-group/edit', element: EditSongGroup, name: 'Дууны бүлэг', menuKey: 'song-group' },

    /*** Song ***/
    // { key: 'song', path: '/song', element: SongList, visible: true, name: 'Дуунууд', icon: IconFileMusic },
    { key: 'create-song', path: '/song/new', element: CreateSong, name: 'Дуунууд', menuKey: 'song' },
    { key: 'edit-song', path: '/song/edit', element: EditSong, name: 'Дуунууд', menuKey: 'song' },
    { key: 'import-song', path: '/song/import-excel', element: ImportExcel, name: 'Дуунууд', menuKey: 'song' },

    /*** Category ***/
    { key: 'categories', path: '/categories', element: CategoryList, visible: true, name: 'Ангилал', icon: IconCategory },
    { key: 'create-category', path: '/categories/new', element: CreateCategory, name: 'Categories', menuKey: 'categories' },
    { key: 'edit-category', path: '/categories/edit', element: EditCategory, name: 'Categories', menuKey: 'categories' },

    /*** Playlist ***/
    { key: 'playlist', path: '/playlist', element: Playlists, visible: true, name: 'Playlist', icon: IconPlaylist },
    { key: 'create-playlist', path: '/playlist/new', element: CreatePlaylist, name: 'Playlist', menuKey: 'playlist' },
    { key: 'edit-playlist', path: '/playlist/edit', element: EditPlaylist, name: 'Playlist', menuKey: 'playlist' },

    { key: 'group-app', path: '', element: CategoryList, visible: true, name: 'Аппликейшн', icon: IconFiles, isGroupHeader: true },

    { key: 'statements', path: '/statement', element: StatementList, visible: true, name: 'Хуулга', icon: IconFileInvoice },
    { key: 'statements-edit', path: '/statement/edit', element: StatementEdit, name: 'Хуулга' },

    /*** Customers ***/
    // { key: 'customers', path: '/customers', element: CustomerList, visible: true, name: 'Апп хэрэглэгч', icon: IconUsers },
    { key: 'customers', path: '/customers', element: CustomerListPaginated  , visible: true, name: 'Апп хэрэглэгч', icon: IconUsers },
    // { key: 'create-customers', path: '/customers/new', element: CreateCategory, name: 'Апп хэрэглэгч' },
    { key: 'edit-customers', path: '/customers/edit', element: EditCustomer, name: 'Апп хэрэглэгч' },
    { key: 'customer-detail', path: '/customers/detail', element: CustomerDetail, name: 'Апп хэрэглэгч' },

    /*** User Subscriptions ***/
    { key: 'user-subscriptions', path: '/user-subscriptions', element: EditUserSubscriptionFilteredList, visible: true, name: 'Худалдан авалт', icon: IconCurrencyTugrik },
    { key: 'create-user-subscriptions', path: '/user-subscriptions/new', element: CreateUserSubscription, name: 'Худалдан авалт', menuKey: 'user-subscriptions' },
    { key: 'edit-user-subscriptions', path: '/user-subscriptions/edit', element: EditUserSubscription, name: 'Худалдан авалт', menuKey: 'user-subscriptions' },

    /*** Sections ***/
    { key: 'sections', path: '/sections', element: SectionList, visible: true, name: 'Нүүр хуудас бүлэг', icon: IconBoxMultiple },
    { key: 'create-sections', path: '/sections/new', element: CreateSection, name: 'Нүүр хуудас бүлэг', menuKey: 'sections' },
    { key: 'edit-sections', path: '/sections/edit', element: EditSection, name: 'Нүүр хуудас бүлэг', menuKey: 'sections' },

    /*** Song Stats ***/
    { key: 'song-stats', path: '/song-stats', element: SongStatsList, visible: true, name: 'Дууны тоолуур', icon: IconChartBar },

    /*** Notification ***/
    { key: 'notification', path: '/notification', element: NotificationList, visible: true, name: 'Сонордуулга', icon: IconBellRinging },
    { key: 'send-notification', path: '/notification/new', element: SendNotification, name: 'Сонордуулга', menuKey: 'notification' },

    /*** Color ***/
    { key: 'color', path: '/color', element: ColorList, visible: true, name: 'Playlist-н өнгө', icon: IconPalette },
    { key: 'create-color', path: '/color/new', element: CreateColor, name: 'Playlist-н өнгө', menuKey: 'color' },
    { key: 'edit-color', path: '/color/edit', element: EditColor, name: 'Playlist-н өнгө', menuKey: 'color' },

    { key: 'group-services', path: '', element: CategoryList, visible: true, name: 'Үйлчилгээ', icon: IconFiles, isGroupHeader: true },

    /*** Subscriptions ***/
    { key: 'subscriptions', path: '/subscriptions', element: SubscriptionList, visible: true, name: 'Багц', icon: IconTags },
    { key: 'create-subscriptions', path: '/subscriptions/new', element: CreateSubscription, name: 'Багц', menuKey: 'subscriptions' },
    { key: 'edit-subscriptions', path: '/subscriptions/edit', element: EditSubscription, name: 'Багц', menuKey: 'subscriptions' },

    /*** Banner ***/
    { key: 'banner', path: '/banner', element: BannerList, visible: true, name: 'Баннер', icon: IconAd },
    { key: 'create-banner', path: '/banner/new', element: CreateBanner, name: 'Баннер', menuKey: 'banner' },
    { key: 'edit-banner', path: '/banner/edit', element: EditBanner, name: 'Баннер', menuKey: 'banner' },

    /*** Article ***/
    { key: 'article', path: '/article', element: ArticleList, visible: true, name: 'Мэдээ', icon: IconNews },
    { key: 'create-article', path: '/article/new', element: CreateArticle, name: 'Мэдээ', menuKey: 'article' },
    { key: 'edit-article', path: '/article/edit', element: EditArticle, name: 'Мэдээ', menuKey: 'article' },

    /*** Contact ***/
    { key: 'contact', path: '/contact', element: ContactList, visible: true, name: 'Холбоо барих', icon: IconPhone },
    { key: 'create-contact', path: '/contact/new', element: CreateContact, name: 'Холбоо барих', menuKey: 'contact' },
    { key: 'edit-contact', path: '/contact/edit', element: EditContact, name: 'Холбоо барих', menuKey: 'contact' },

    { key: 'group-system', path: '', element: CategoryList, visible: true, name: 'Систем', icon: IconFiles, isGroupHeader: true },

    /*** Users ***/
    { key: 'users', path: '/users', element: UserList, visible: true, name: 'Системийн хэрэглэгч', icon: IconRobot },
    { key: 'create-user', path: '/users/new', element: CreateUser, name: 'Системийн хэрэглэгч', menuKey: 'users' },
    { key: 'edit-user', path: '/users/edit', element: EditUser, name: 'Системийн хэрэглэгч', menuKey: 'users' },

    /*** App Version ***/
    { key: 'version', path: '/version', element: VersionList, visible: true, name: 'Апп хувилбар', icon: Icon123 },
    // { key: 'create-version', path: '/version/new', element: CreateVersion, name: 'App Version', menuKey: 'version' },
    { key: 'edit-version', path: '/version/edit', element: EditVersion, name: 'Апп хувилбар', menuKey: 'version' },
];

export default routes;